<div class="mp-header">
	<div class="mp-toolbar mp-toolbar--warning">
		<div class="mp-toolbar__content">
			<div class="container-header">
				<span class="mp-label title text-wrap" translate>Unavailable Items</span>
			</div>
		</div>
	</div>
</div>

<div class="mp-content ion-padding modal-content-scroll">
	<div class="center-div-message">
		<div class="alert-icon-container">
			<img src="assets/icon/warning.svg" alt="Aviso" class="alert-icon">
		</div>

		<p class="alert-message" translate>
			Some items from your last order are no longer available in the current menu:
		</p>

		<div class="removed-items-list">
			<div *ngFor="let removed of removedItems" class="removed-item">
				<div class="item-name">
					<strong>{{ removed.item.name }}</strong>
				</div>
				<div class="item-reason">
					{{ removed.motivo }}
				</div>
			</div>
		</div>

		<p class="info-message" *ngIf="hasValidItems" translate>
			Available items have been added to your cart.
		</p>
	</div>
</div>

<div class="mp-footer">
	<button class="mp-button mp-button--ios mp-button--warning mp-button--block mp-button--small mb-1"
		style="font-weight: 800; font-size: 1.0em;" (click)="dismiss()" translate>
		Got it
	</button>
</div>
